(function () {
    angular.module('agweb').controller('ServicesController', ['$http', '$scope',
        function ServicesController($http, $scope) {
            let ctrl = this;

            ctrl.ux = {
                loadAddress: false,
            };
            
            ctrl.addressList = [];
            ctrl.isMobile = tios.util.isMobile();

            ctrl.formObj = {
                firstName: '',
                surname: '',
                email: '',
                phone: '',
                address: '',
                movingFrom: '',
                movingTo: '',
                contactTime: ''
            };

            //-
            ctrl.selectAddress = function (address) {
                ctrl.formObj.address = address.DisplayString;
                ctrl.postcode = address.Postcode;
            };

            ctrl.pcLookup = function () {
                global.blockAction('services.js::ctrl.pcLookup');
                ctrl.ux.loadAddress = true;

                ctrl.formObj.address = null;

                $http({
                    url: urls.Api + 'Util/IdealPostcode',
                    method: 'POST',
                    data: { Postcode: ctrl.postcode }
                }).then(function success(response) {
                    var rd = response?.data;
                    if (rd) {
                        if (!rd.PostcodeEmptyMessage) {
                            if (rd.Addresses.length === 1) {
                                ctrl.selectAddress(rd.Addresses[0]);
                            } else {
                                ctrl.addressList = rd.Addresses;
                            }
                        } else {
                            global.showConfirm({ title: 'Address not found', message: rd.PostcodeEmptyMessage });
                        }
                    }
                    global.unBlock();
                    ctrl.ux.loadAddress = false;
                }, function error(response) {
                    console.error('Error in services.js::pcLookup(): ', response);
                });
            };

            ctrl.nextStage = function (isValid, type) {
                if (isValid) {
                    global.blockAction('services.js::ctrl.nextStage');

                    $http({
                        url: urls.Api + 'Util/SendReferral',
                        method: 'POST',
                        data: {
                            ReferralType: type,
                            FirstName: ctrl.formObj.firstName,
                            Surname: ctrl.formObj.surname,
                            Email: ctrl.formObj.email,
                            Phone: ctrl.formObj.phone,
                            Address: ctrl.formObj.address,
                            MovingFrom: ctrl.formObj.movingFrom,
                            MovingTo: ctrl.formObj.movingTo,
                            ContactTime: ctrl.formObj.contactTime
                        }
                    }).then(response => {
                        let rd = response?.data;
                        if (rd) {
                            $scope.$applyAsync(() => ctrl.referralSuccess = rd.Success);
                        }

                        global.unBlock();
                    }, error => console.error('Error in services.js::ctrl.nextStage: ', error));
                }
            };
        }
    ]);
})();